import { render, staticRenderFns } from "./loginVerify.vue?vue&type=template&id=6dd878cb"
import script from "./loginVerify.vue?vue&type=script&lang=js"
export * from "./loginVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports